import { Box, Card, Typography } from "@mui/material";
import helpers from "../../../hooks/HelperFunctions";

// Same tile shape as components/payments/common/StatusCards.jsx (the Payments
// Home page's stat cards) — icon top-right, big number, label — so every tab
// on the Reports page reads as the same product rather than a bolted-on
// admin screen. Shared across the Reports tabs (Revenue & Budget, Revenue
// Trend) rather than redefined per file.
export default function SummaryTile({ label, value, icon }) {
    return (
        <Card
            sx={{
                flex: "1 1 200px",
                minWidth: 170,
                p: { xs: 1.5, sm: 2 },
                borderRadius: 2,
                boxShadow: 0,
                border: "1px solid rgba(0,0,0,0.06)",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "flex-end", "& svg": { color: "#FF8C42", fontSize: 22 } }}>
                {icon}
            </Box>
            <Typography sx={{ fontSize: { xs: "1.05rem", sm: "1.2rem" }, fontWeight: 700, lineHeight: 1.2 }}>
                {helpers.formatNumber(value, true)}
            </Typography>
            <Typography sx={{ mt: 0.3, fontSize: 12.5, color: "text.secondary" }}>{label}</Typography>
        </Card>
    );
}
